import { uiSetGlobalCursor, uiSetOverflowAnchor } from './functions';
import { UITouchDelegate, UITouchEvent } from './touch';
import { UIPoint } from './types';

export interface UIOrderDelegate {
    orderStart(): void;
    orderMove(offset: UIPoint): DOMRect;
    orderEnd(): void;
}

export function uiStartOrder(e: UITouchEvent, delegate: UIOrderDelegate | undefined): UITouchDelegate | false {
    if(!delegate) return false;

    const touch = e.touch;

    const start_pos = [touch.x + window.scrollX, touch.y + window.scrollY];
    let scroll_token: {} | undefined;
    let started = false;
    uiSetGlobalCursor('grabbing');

    return {
        touchMove: () => {
            scroll_token = undefined;

            if(!started) {
                delegate.orderStart();
                started = true;
                uiSetOverflowAnchor(false);
            }

            const offset: UIPoint = [touch.x + window.scrollX - start_pos[0], touch.y + window.scrollY - start_pos[1]];

            const rect = delegate.orderMove(offset);

            if(rect.top < 0 && touch.dy < -20) {
                const s = -Math.round(Math.pow(Math.min(-touch.dy - 20, -rect.top), 1 / 3));
                window.scrollBy(0, s);

                const token = scroll_token = {};

                const callback = () => {
                    if(token != scroll_token) return;
                    offset[1] += s;
                    const rect = delegate.orderMove(offset);
                    if(rect.top < 0) {
                        window.scrollBy(0, s);
                        requestAnimationFrame(callback);
                    }
                }

                requestAnimationFrame(callback);
            } else if(rect.bottom > window.innerHeight && touch.dy > 20) {
                const s = Math.round(Math.pow(Math.min(touch.dy - 20, rect.bottom - window.innerHeight), 1 / 3));
                window.scrollBy(0, s);

                const token = scroll_token = {};

                const callback = () => {
                    if(token != scroll_token) return;
                    offset[1] += s;
                    const rect = delegate.orderMove(offset);
                    if(rect.bottom > window.innerHeight) {
                        window.scrollBy(0, s);
                        requestAnimationFrame(callback);
                    }
                }

                requestAnimationFrame(callback);
            }

            return true;
        },
        touchEnd: () => {
            uiSetGlobalCursor(null);
            scroll_token = undefined;

            if(started) {
                uiSetOverflowAnchor(true);
                delegate.orderEnd();
                started = false;
            }

            return true;
        },
        stop: true
    };
}
